import { createSelector } from '@reduxjs/toolkit';
import { LocalesState, LOCALES_SLICE_NAME } from './models';
import { RootState } from '@/store';

export const localesSelector = (state: RootState): LocalesState => state[LOCALES_SLICE_NAME];

export const selectAvailableLocales = createSelector(
  localesSelector,
  (locales: LocalesState) => locales.availableLocales,
);
